import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { EyeOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { useI18n } from 'components/I18nProvider';
import styles from './style.module.scss';
const statusLedClassName = {
    ok: styles.statusLedOk,
    warning: styles.statusLedWarning,
    error: styles.statusLedError,
    muted: styles.statusLedMuted,
};
const EventStatusBar = ({ led, message, segmentTitle, viewerCount }) => {
    const { intl } = useI18n();
    return (_jsxs("div", { className: styles.statusBar, role: "status", children: [_jsxs("div", { className: styles.statusMain, children: [_jsx("span", { className: `${styles.statusLed} ${statusLedClassName[led]}`, "aria-hidden": true }), segmentTitle !== undefined && (_jsx("strong", { children: `${segmentTitle}:` })), _jsx("span", { children: message })] }), viewerCount != null && (_jsx(Tooltip, { title: intl.formatMessage({ id: 'viewerCountTooltip' }), children: _jsxs("span", { className: styles.viewerCount, "aria-label": `${viewerCount} viewers`, children: [_jsx(EyeOutlined, { "aria-hidden": true }), viewerCount] }) }))] }));
};
export default EventStatusBar;
